import { render } from "./Editor.vue?vue&type=template&id=64668d2c"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=64668d2c&lang=scss"

import exportComponent from "/var/www/distan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__